import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({ name: 'ActionUserInputHorizontal' })(
  ({ brandColors }, props) => ({
    container: {
      backgroundColor: darkOrLightStyle(props)(
        brandColors.tintsHeroBlue20,
        brandColors.tintsOffWhite60
      ),
    },
    wrapper: {
      justifyContent: 'center',
    },
  })
);

export default useStyles;
